/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LearnMoreDialogComponent } from '../components/learn-more-dialog/learn-more-dialog.component';

@Injectable()
export class LearnMoreDialogService {
	constructor(public dialog: MatDialog) {}

	openDialog(template: TemplateRef<any>, config?: { width?: string }): void {
		this.dialog.open(LearnMoreDialogComponent, {
			width: config?.width ?? '500px',
			data: { customContent: template },
		});
	}
	closeDialog(): void {
		this.dialog.closeAll();
	}
}
